<template>
<div>
  <v-select  :options="selections" v-model="selected" @input="setSelected" :clearable="false"></v-select>
  </div>
</template>

<script>
export default {
  name: "sort-filter",
  props: {
    filters: {
      type: String,
      required: true
    },
    selection: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    selected: {}
  }),
  created() {

    if (this.selection.length) {
      this.selected = this.selections.filter(obj => {
        return obj.code === this.selection;
      });
    } else {
      this.selected = this.selections[0];
    }

  },
  methods: {
    setSelected(value) {
      this.selected = this.selected == {} ? this.selections[0] : value; 
      this.insertParam("sort", this.selected.code);
    
    },
    insertParam(key, value) {
      key = encodeURI(key);
      value = encodeURI(value);
      let re = /page=\d/gi; 
      let documentsearch = document.location.search;
      documentsearch = documentsearch.replace(re, "page=1"); 

      let kvp = documentsearch.substr(1).split("&");  

     

      let i = kvp.length;
      let x;
      while (i--) {
        x = kvp[i].split("=");
 
        if (x[0] == key) {
          x[1] = value;
          kvp[i] = x.join("=");
          break;
        }
      }

      if (i < 0) {
        kvp[kvp.length] = [key, value].join("=");
      }

      //this will reload the page, it's likely better to store this until finished
      document.location.search = kvp.join("&");
    }
  },
  computed: {
    selections: function() {
      return JSON.parse(this.filters);
    }
  }
};
</script>
